import { Link } from "react-router-dom";
import { motion } from "motion/react";
import { Thumb } from "./Thumb";
import { PieceMeta } from "./PieceRow";
import { Skeleton } from "../../components/ui";
import { haptic } from "../../telegram/haptics";
import { listItem, pressTile } from "../../motion";
import { isLatinScript } from "../../i18n/format";
import { useT } from "../../i18n/strings";
import type { PieceRow as Row } from "../../api/types";
import s from "./pieces.module.css";

/** The tray view: the piece takes the tile, the label sits under it unboxed. */
export function PieceCard({ piece, onMediaError }: { piece: Row; onMediaError?: () => void }) {
  const t = useT();
  const latin = isLatinScript(piece.title);

  return (
    <motion.div variants={listItem} exit="exit" layout="position">
      <motion.div {...pressTile}>
        <Link to={`/piece/${piece.id}`} className={s.card} onClick={() => haptic.tap()}>
          <span className={`${s.cardMat} paper`}>
            <Thumb
              media={piece.primary_media}
              layoutId={piece.primary_media ? `hero-${piece.primary_media.id}` : undefined}
              onMediaError={onMediaError}
              className={s.cardThumb}
              iconSize={32}
            />
          </span>
          <div className={s.cardBody}>
            <span
              className={[s.cardTitle, latin && s.titleLatin, "bidi"].filter(Boolean).join(" ")}
            >
              {piece.title || t.detail.untitled}
            </span>
            <span className={s.cardMeta}>
              <PieceMeta piece={piece} compact />
            </span>
          </div>
        </Link>
      </motion.div>
    </motion.div>
  );
}

/** The mat is part of the shape, so the card does not resize when the image lands. */
export function PieceCardSkeleton() {
  return (
    <div className={s.skeletonCard}>
      <span className={`${s.cardMat} paper`}>
        <Skeleton height="100%" radius="2px" />
      </span>
      <Skeleton height={13} width="70%" radius="4px" />
      <Skeleton height={11} width="45%" radius="4px" />
    </div>
  );
}
